export const fn = 'function';
export const number = 'number';
export const password = 'password';
export const object = 'object';
export const string = 'string';
export const undef = 'undefined';
